import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import styles from "@/styles/Link.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
/**
 * WebView時にdeeplinkに書き換えるページをここで指定する。webのpath: アプリのpath
 * @type {Object.<string, string>}
 */

/**
 *WebViewで表示時、受け取ったhrefがpathsDictionaryにマッチした場合、deeplinkに書き換える。deeplinkの書き換えはページ名/[id]の形式のページに対してのみ動作する。(このコンポーネントをラップした要素の中にボタンがある場合、必ずそのボタンのコールバックでstopPropagationを呼び出すこと。)
 *@param {Object} props
 *@param {String} props.href - ページのpath
 *@param {React.element} props.children - このコンポーネントで括った親コンポーネントのDOM
 *@param {String} className - クラス名
 *@param {Object} ...props - その他props
 *@returns {React.element}
 */
function VersatileLink({ href, children, className = "", ...props }) {
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery();
  const router = useRouter();

  const judgedLink = useMemo(() => {
    const { isWebView, isAndroid } = deviceInfo ?? {};
    const isIOS = maybeIOS(deviceInfo);
    const regex = new RegExp(`^/?(?<path>watch|title)/(?<id>\\d+)`);
    const matched = href.match(regex);

    if (matched && isWebView) {
      const { id } = matched.groups;
      if (isIOS) return `spooxnew://works/${id}`;
      if (isAndroid)
        return `intent://works/${id}#Intent;scheme=spooxnew;package=${config.androidNewPackageName};end`;
    }
    return href;
  }, [deviceInfo, href]);

  const isWatchPageFlag =
    router.asPath.includes("/watch") &&
    href.includes("/watch") &&
    !judgedLink.includes("spoox://") &&
    !judgedLink.includes("intent://");

  const handleWatchPageClick = useCallback(() => {
    window.location.replace(judgedLink);
  }, [judgedLink]);

  if (!isWatchPageFlag) {
    return (
      <Link {...props} href={judgedLink} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <div
      {...props}
      className={`${styles.watchLink} ${className}`.trim()}
      onClick={handleWatchPageClick}
      role="link"
      tabIndex={0}
    >
      {children}
    </div>
  );
}

export default VersatileLink;
